function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "33px",
    height: "35px",
    viewBox: "0 0 33 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 24.558594 7.933594 C 24.558594 12.316406 20.949219 15.867188 16.5 15.867188 C 12.050781 15.867188 8.441406 12.316406 8.441406 7.933594 C 8.441406 3.550781 12.050781 0 16.5 0 C 20.949219 0 24.558594 3.550781 24.558594 7.933594 Z M 24.558594 7.933594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 33 34 C 28.394531 34 25.230469 34 16.117188 34 C 7.003906 34 3.835938 34 0 34 C 0 25.027344 7.386719 18.132812 16.5 18.132812 C 25.613281 18.132812 33 25.027344 33 34 Z M 33 34 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.48a77f2341159c8496fe4a967b964540.svg";
export { ForwardRef as ReactComponent };